import { Box, Button, Dialog, Grid } from "@mui/material";
import usePrintParameterInput from "./hooks/usePrintParameterInput";
import returnPrintParameter from "./const/PrintParameterReturnValue";
import PRINT_PARAMETER_FORMS from "./const/PrintParameterForms";

/**
 * 帳票印刷設定ダイアログ
 */
const PrintParameterDialog = ({dialogStatus, printSetting}) => {

  const printParameterInput = usePrintParameterInput(printSetting);
  const PrintParameterForm = PRINT_PARAMETER_FORMS[printSetting.Value.reportTypeId] || PRINT_PARAMETER_FORMS['default'];

  return (
    <Dialog
      open={dialogStatus.isOpen}
      onClose={dialogStatus.onClose(null)}
      maxWidth={false}
    >
      <Box padding={2} width='700px'>
        <Box mb={1}>
          <PrintParameterForm
            printParameterInput={printParameterInput}
            onCancel={dialogStatus.onClose(null)}
          />
        </Box>
        <ButtonPart>
          <PrintButton
            onClick={dialogStatus.onClose(returnPrintParameter(printSetting, printParameterInput.value))}
            disabled={!printParameterInput.isValidForm}
          />
          <CancelButton
            onClick={dialogStatus.onClose(null)}
          />
        </ButtonPart>
      </Box>
      
    </Dialog>
  );
};

const PrintButton = ({onClick, disabled}) => (
  <Button
    variant='contained'
    onClick={onClick}
    disabled={disabled}
  >
    印刷
  </Button>
);

const CancelButton = ({onClick}) => (
  <Button
    variant='contained'
    color="error"
    onClick={onClick}
  >
    キャンセル
  </Button>
);

const ButtonPart = ({children}) => (
  <Grid container spacing={2}>
    <Grid item xs/>
    {
      children.map((button) => (
        <Grid item xs='auto'>
          {button}
        </Grid>
      ))
    }
  </Grid>
)

export default PrintParameterDialog;
